import React, { useEffect, useState } from 'react';
import './ViewAccessRequest.css';
import { Drawer, Table, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { SettingsWorkspaceAccessTokenRequestsActionHandler } from '../../../../../Redux/Actions/user/SettingsWorkspaceAccessTokenRequestsActions';
import { SettingsActionWorkspaceAccessTokenRequestsActionHandler } from '../../../../../Redux/Actions/user/SettingsActionWorkspaceAccessTokenRequestsActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);
const { Text } = Typography;
const ViewAccessRequestToken = ({
    isViewAccessRequestOpenToken,
    ViewAccessRequestOverlayToken,
}) => {
    const SideClose = '/assets/ModalClose.svg';
    let dispatch = useDispatch();
    const [actionsvalue, setActionsValue] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const settingsworkspaceaccesstokenrequestsData = useSelector(
        (state) =>
            state?.SettingsWorkspaceAccessTokenRequestsData
                ?.settings_workspace_access_token_requests_data
    );
    const settingsactionworkspaceaccesstokenrequestsData = useSelector(
        (state) =>
            state?.SettingsActionWorkspaceAccessTokenRequestsData
                ?.settings_action_workspace_access_token_requests_data
    );

    const fetchData = async () => {
        try {
            dispatch(
                SettingsWorkspaceAccessTokenRequestsActionHandler(currentPage)
            );
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'requested_by',
            key: 'requested_by',
            sorter: (a, b) =>
                `${a.first_name} ${a.last_name}`.localeCompare(
                    `${b.first_name} ${b.last_name}`
                ),
            render: (text, record) =>
                `${record.first_name} ${record.last_name}`,
        },
        {
            title: 'Workspace Name',
            dataIndex: 'workspace_name',
            key: 'workspace_name',
            sorter: (a, b) => a.workspace_name.localeCompare(b.workspace_name),
        },
        {
            title: 'Token',
            dataIndex: 'requested_tokens',
            key: 'requested_tokens',
            sorter: (a, b) =>
                a.requested_tokens.localeCompare(b.requested_tokens),
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <div className='view-access-request-action'>
                    <div>
                        <Text
                            type='success'
                            className='save-user-actions accept'
                            onClick={() =>
                                handleWorkspaceRequest('ACCEPTED', record.id)
                            }>
                            ACCEPTED
                        </Text>
                    </div>
                    <div>
                        <Text
                            type='danger'
                            className='save-user-actions reject'
                            onClick={() =>
                                handleWorkspaceRequest('REJECTED', record.id)
                            }>
                            REJECTED
                        </Text>
                    </div>
                </div>
            ),
        },
    ];
    const handleWorkspaceRequest = async (values, id) => {
        setActionsValue(values === 'ACCEPTED' ? 'Approve' : 'Reject');
        MySwal.fire({
            title: `Are you sure ${
                values === 'ACCEPTED' ? 'Approve' : 'Reject'
            } Request?`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const data = {
                        id: id,
                        action: values,
                    };

                    dispatch(
                        SettingsActionWorkspaceAccessTokenRequestsActionHandler(
                            data
                        )
                    );
                } catch (error) {
                    console.error('Error deleting user:', error);
                }
            }
        });
    };

    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (settingsactionworkspaceaccesstokenrequestsData.message) {
            MySwal.fire(
                'Request!',
                `has been ${actionsvalue} Request.`,
                'success'
            );
            setTimeout(() => {
                MySwal.close();
            }, 2000);
            fetchData();
        }
    }, [settingsactionworkspaceaccesstokenrequestsData]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(SettingsWorkspaceAccessTokenRequestsActionHandler(page));
    };
    return (
        <>
            <Drawer
                placement='right'
                closable={false}
                onClose={ViewAccessRequestOverlayToken}
                open={isViewAccessRequestOpenToken}
                key='right'
                width={'40%'}>
                <div>
                    <div>
                        <div className='view-access-request-icon'>
                            <h1>Credit Requests</h1>
                            <img
                                onClick={ViewAccessRequestOverlayToken}
                                src={SideClose}
                                alt=''
                                className='view-access-request-drawer'
                            />
                        </div>
                        <div className='view-access-request-add-action-table'>
                            <Table
                                bordered
                                columns={columns}
                                dataSource={
                                    settingsworkspaceaccesstokenrequestsData
                                        ?.data?.data
                                }
                                size='middle'
                                pagination={{
                                    pageSize:
                                        settingsworkspaceaccesstokenrequestsData
                                            ?.data?.per_page,
                                    total: settingsworkspaceaccesstokenrequestsData
                                        ?.data?.total,
                                    showSizeChanger: false,
                                    onChange: handlePageChange,
                                }}
                                className='mytable'
                            />
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    );
};
export default ViewAccessRequestToken;
